import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { RootState } from './store/store'
import { setupStore } from './store/store'; // is it what it means?
import { Provider } from "react-redux";



const store = setupStore();
const modalRoot = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(modalRoot);


//http://localhost:3000?linkFrom=https%3A%2F%2Fapi.github.com%2Frepos%2FGazsoo%2FundoExperiment%2Fcontents%2Fpublic%2FBuildingDrawing.json%3Fref%3Dexperiment0


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(null);
